import {
  ALL_TASK_VIEW_FLAGS,
  effectiveViewMode,
  enabledViewModes,
  showTaskViewSwitcher,
} from '../lib/tasks/taskViews';
import { useTaskViewFlags } from './queries/useCabinetSettings';
import { useTasksStore, type ViewMode } from '../store/tasksStore';

export function useEffectiveTaskView() {
  const stored = useTasksStore((s) => s.viewMode);
  const { data: flags } = useTaskViewFlags();
  const resolved = flags ?? ALL_TASK_VIEW_FLAGS;
  const enabled: ViewMode[] = flags ? enabledViewModes(flags) : ['list'];
  const viewMode = effectiveViewMode(stored, resolved);
  return {
    viewMode,
    enabled,
    flags: resolved,
    showSwitcher: showTaskViewSwitcher(flags),
  };
}
